module.exports = __webpack_public_path__ + "img/12.18abf52a.jpg";